// ============================================================================
// HUFFMAN CODING - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'huffman-coding',
  name: 'Huffman Coding',
  category: 'Greedy',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Huffman Coding builds optimal prefix codes using greedy approach with priority queue. More frequent characters get shorter codes for lossless compression.'
};
export type MetaType = typeof meta;
